import { MODALITY, type Modality } from "@src/constants/filter-constants";
import { isUnder12AgeRange } from "@src/utils/scheduling-metadata";
import {
  normalizeSessionTypeToken,
  resolveModalityFromNormalizedSessionTypes,
  toSessionTypeValues,
} from "@src/utils/session-type-normalization";

type SessionTypeInput = string | string[] | null | undefined;
/**
 * Normalizes Get Started session type values into provider-search modality values.
 */
export const resolveModalityFromSessionType = (sessionType?: SessionTypeInput): Modality => {
  const values = toSessionTypeValues(sessionType);

  return resolveModalityFromNormalizedSessionTypes(values);
};

export const hasMixedSessionTypes = (sessionType?: SessionTypeInput): boolean => {
  const normalized = new Set(toSessionTypeValues(sessionType).map(normalizeSessionTypeToken));

  const hasVirtual = normalized.has(MODALITY.TELEHEALTH);
  const hasInPerson = normalized.has(MODALITY.IN_PERSON);

  return hasVirtual && hasInPerson;
};

/**
 * Resolves modality for provider search, enforcing in-person for under-12 patients
 * regardless of their selected session type.
 */
export const resolveModalityFromAgeAndSessionType = (
  ageRange?: string | null,
  sessionType?: string | string[] | null,
): Modality => {
  if (isUnder12AgeRange(ageRange)) {
    return MODALITY.IN_PERSON;
  }
  return resolveModalityFromSessionType(sessionType);
};
